/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     通用配置数据管理
  +--------------------------------------------------------------------------------------
*/

const commonStore = {
  state: {
    collapse: true, // Frame展开
    pindexChange: false,
    psize: Number(localStorage.getItem('__PSIZE__')) || 10,
    defaultAvatar: 'this.src="' + require('@/assets/default-avatar.png') + '"',
    defaultEquipAvatar: 'this.src="' + require('@/assets/default-equip-avatar.png') + '"',
    noPic: 'this.src="' + require('@/assets/no-pic.png') + '"',
    fileUploadUrl: process.env.VUE_APP_API_HOST + '?c=utility&a=file&do=upload',
    defaultConsoleTitle: 'AIoT 平台',
    defaultGroupId: '',
  },

  mutations: {
    SET_PSIZE: (state, val) => {
      localStorage.setItem('__PSIZE__', val || 10)
      state.psize = val || 10
    },

    SET_PINDEX_CHANGE: (state, val) => {
      state.pindexChange = val
    },

    SET_COLLAPSE: (state, val) => {
      localStorage.setItem("__COLLAPSE__", val || false);
      state.collapse = val || false;
    },

    SET_GROUPID: (state, val) => {
      state.defaultGroupId = val;
    },
  },

  actions: {
  }
}

export default commonStore
